import { useContext } from 'react';
import _noop from 'lodash/noop';

import { ModalContext } from 'commons-ui';
import useService from './useService';
import { IBankUpiHandleParams } from './components/unsetBankAccount/model/bankUpiDetail.model';

const useHandler = (params: IBankUpiHandleParams) => {
	const { setForceUpdate = _noop, getUpiAndBankDetails, getBasicUserInfo } = params;
	const { unsetUpiId, unsetAccountNumber } = useService();
	const { setModalConfig } = useContext(ModalContext);

	const onAgreeUnsetAccount = async () => {
		setModalConfig({ isOpen: false });
		await unsetAccountNumber();
		await getUpiAndBankDetails();
		await getBasicUserInfo();
		setForceUpdate(true);
	};
	const onDisAgreeUnsetAccount = () => {
		setModalConfig({ isOpen: false });
	};

	const onAgreeUnsetUpiId = async () => {
		setModalConfig({ isOpen: false });
		await unsetUpiId();
		await getUpiAndBankDetails();
		await getBasicUserInfo();
		setForceUpdate(true);
	};
	const onDisAgreeUnsetUpiId = () => {
		setModalConfig({ isOpen: false });
	};

	return {
		onAgreeUnsetAccount,
		onDisAgreeUnsetAccount,
		onAgreeUnsetUpiId,
		onDisAgreeUnsetUpiId
	};
};

export default useHandler;
